<template>
  <div class="m-map-page">

    <!-- ── 搜尋列（可收合） ───────────────────────────────────── -->
    <div class="m-search-bar">
      <div class="m-search-toggle" @click="searchExpanded = !searchExpanded">
        <span><i class="el-icon-search"></i> 查詢條件</span>
        <div class="m-toggle-right">
          <span v-if="lstQuery.length > 0" class="m-cond-badge">{{ lstQuery.length }}</span>
          <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </div>

      <el-collapse-transition>
        <div v-show="searchExpanded" class="m-search-body">
          <!-- Row 1：主搜尋 -->
          <div class="m-section">
            <div class="m-search-row">
              <div class="m-field-inline" style="flex: 1.2;">
                <label>行政區</label>
                <DistSelection
                  v-model="selectedAreaValue"
                  width="100%"
                  @area-change="handleAreaChange"
                />
              </div>
              <div class="m-field-inline" style="flex: 1.5;">
                <label>關鍵字</label>
                <el-input
                  v-model="keyword"
                  placeholder="公司名稱 / 統一編號 / 關鍵詞"
                  clearable
                  @clear="handleClearInput"
                />
              </div>
              <el-button type="primary" icon="el-icon-search" size="small" @click="handleMobileSearch">查詢</el-button>
            </div>
          </div>

          <!-- Row 2：已選條件 -->
          <div class="m-active-tags">
            <div class="m-active-tags-row">
              <div v-if="lstQuery.length > 0" class="m-active-tags-main">
                <span class="m-filter-label m-active-tags-label">已選條件</span>
                <div class="m-active-tags-list">
                  <el-tag
                    v-for="tag in lstQuery"
                    :key="tag"
                    type="success"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >{{ tag }}</el-tag>
                </div>
              </div>
              <div class="m-search-actions m-search-actions--inline">
                <el-button v-if="btnHotTag" size="small" @click="doTagsCloud" icon="el-icon-price-tag">熱門標籤</el-button>                
                <el-button size="small" @click="doClearTags" icon="el-icon-delete">清空條件</el-button>
              </div>
            </div>
          </div>

          <!-- Row 3：篩選條件 -->
          <div class="m-section">
            <div class="m-filter-row">
              <span class="m-filter-label">篩選條件</span>

              <el-dropdown placement="bottom-start" trigger="click" @command="comStatusChangeHandler">
                <span class="m-filter-btn">公司狀況 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                  <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-start" trigger="click" @command="comTypeChangeHandler">
                <span class="m-filter-btn">公司類別 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                    {{ item.comType }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-start" trigger="click" @command="orgTypeChangeHandler">
                <span class="m-filter-btn">組織別 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                    {{ item.comType }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-checkbox v-model="IsCustomer" @change="otherChangeHandler('既有客戶')">既有客戶</el-checkbox>
              <el-checkbox v-model="IsInvoice"  @change="otherChangeHandler('有發票')">有發票</el-checkbox>
              <el-checkbox v-model="IsImport"   @change="otherChangeHandler('有進口')">有進口</el-checkbox>
              <el-checkbox v-model="IsExport"   @change="otherChangeHandler('有出口')">有出口</el-checkbox>
              <el-checkbox v-model="IsFactory"  @change="otherChangeHandler('有工廠')">有工廠</el-checkbox>
            </div>
          </div>

          <!-- Row 4：進階條件 -->
          <div class="m-section">
            <div class="m-filter-row">
              <span class="m-filter-label">進階條件</span>

              <el-dropdown placement="bottom-end" trigger="click" @command="radClick">
                <span class="m-filter-btn">實收資本 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="c in capList" :key="c.value" :command="c.value">{{ c.cap }}</el-dropdown-item>
                  <el-dropdown-item command="custom">自訂區間</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-end" trigger="click" @command="yearClick">
                <span class="m-filter-btn">設立年數 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="c in yearList" :key="c.value" :command="c.value">{{ c.cap }}</el-dropdown-item>
                  <el-dropdown-item command="custom">自訂區間</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <div class="m-field-inline" style="flex: 1; min-width: 180px;">
                <label>行業代號</label>
                <IndusCodeSelection
                  size="small"
                  v-model="selectedIndustryCode"
                  @change="handleIndustryCodeChange"
                />
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <!-- ── 地圖（全版面） ─────────────────────────────────────── -->
    <div id="map" class="m-map-container">

      <!-- 定位按鈕 -->
      <div class="m-map-ctrl">
        <el-button
          type="primary"
          :icon="isLocating ? 'el-icon-loading' : 'el-icon-location'"
          circle
          :loading="isLocating"
          :title="isLocating ? '正在定位中...' : '定位到我的位置'"
          @click="handleLocationClick"
        />
      </div>

      <!-- 展開結果列表按鈕（有結果時顯示） -->
      <div
        v-if="!drawerVisible && tabledata.length > 0"
        class="m-result-fab"
        @click="drawerVisible = true"
      >
        <i class="el-icon-tickets"></i>
        <span>{{ totalLists }} 筆結果</span>
      </div>
    </div>

    <!-- ── 右側結果列表抽屜（同桌面版，寬度調整為 iPad 適合） ── -->
    <el-drawer
      title="查詢公司結果列表"
      :visible.sync="drawerVisible"
      direction="rtl"
      :size="drawerWidth"
      :with-header="true"
      :show-close="tabledata.length === 0"
      :close-on-click-modal="tabledata.length === 0"
      :close-on-press-escape="tabledata.length === 0"
      :modal="false"
    >
      <div class="drawer-content">
        <el-card
          v-for="item in tabledata"
          :key="`${item.UniComNm}-${item.Branch}`"
          class="compact-card"
          style="margin-bottom: 0.4rem;"
          :body-style="{ padding: '0 0.5rem' }"
        >
          <div class="card-container">
            <!-- 主要資訊 -->
            <div
              class="card-content-wrapper"
              style="cursor: pointer;"
              @click="doshowMap(item, tabledata.indexOf(item) + 1)"
            >
              <div class="card-content">
                <h3>
                  <span class="item-number">{{ tabledata.indexOf(item) + 1 }}.</span>
                  <span class="unicodeBox">{{ item.UniComNm }}</span>
                </h3>
                <p class="card-branchname">{{ item.Branch }}</p>
                <p class="card-info">
                  <span v-if="item.RepName">負責人: {{ item.RepName }}</span>
                  <span v-if="item.Tel"> - 電話: {{ item.Tel }}</span>
                </p>
              </div>
            </div>

            <!-- 操作按鈕區 -->
            <div class="card-action-buttons">
              <div class="circular-button" @click.stop="handleTagClick(item)">
                <el-tooltip content="查看標籤" placement="top" effect="light">
                  <i class="el-icon-collection-tag"></i>
                </el-tooltip>
                <div class="button-label">標籤</div>
              </div>
              <div class="circular-button-green" @click.stop="doShowCompanyDetail(item)">
                <el-tooltip content="公司登記資訊" placement="top">
                  <i class="el-icon-document"></i>
                </el-tooltip>
                <div class="button-label">公司登記</div>
              </div>
              <div class="circular-button-green" @click.stop="doshowDetail(item)">
                <el-tooltip content="企業標籤" placement="top">
                  <i class="el-icon-sell"></i>
                </el-tooltip>
                <div class="button-label">企業標籤</div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 分頁 -->
        <div class="pageBox">
          <PageBrief
            @currentChange="pageChange"
            :pageSize="listQuery.Page_Size"
            :propsCurrentPage="listQuery.Page_Num"
            :prevNextOnly="true"  
            :totalLists="totalLists"
          />
        </div>
      </div>
    </el-drawer>

    <!-- ── 左側標籤抽屜（保留原版功能） ────────────────────── -->
    <el-drawer
      :title="(selectedCompanyTags.company && selectedCompanyTags.company.Branch ? selectedCompanyTags.company.Branch : '') + ' 標籤資訊'"
      :visible.sync="tagDrawerVisible"
      direction="ltr"
      :size="tagDrawerWidth"
      :with-header="true"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :modal="false"
    >
      <div class="tag-drawer-content" v-if="selectedCompanyTags.company">
        <!-- 公司基本資訊 -->
        <div class="company-info-section">
          <h3 class="section-title"><i class="el-icon-office-building"></i> 公司資訊</h3>
          <div class="company-details">
            <p><strong>公司名稱：</strong>{{ selectedCompanyTags.company.Branch }}</p>
            <p><strong>統一編號：</strong>{{ selectedCompanyTags.company.UniComNm }}</p>
            <p v-if="selectedCompanyTags.company.RepName"><strong>負責人：</strong>{{ selectedCompanyTags.company.RepName }}</p>
            <p v-if="selectedCompanyTags.company.ComLoc"><strong>地址：</strong>{{ selectedCompanyTags.company.ComLoc }}</p>
            <p v-if="selectedCompanyTags.company.Tel"><strong>電話：</strong>{{ selectedCompanyTags.company.Tel }}</p>
            <p v-if="selectedCompanyTags.company.Cap"><strong>資本額：</strong>{{ capFormat(selectedCompanyTags.company.Cap) }}</p>
            <p v-if="selectedCompanyTags.company.EstDate"><strong>設立日期：</strong>{{ selectedCompanyTags.company.EstDate }}</p>
            <p v-if="selectedCompanyTags.company.IndustryName"><strong>行業：</strong>{{ selectedCompanyTags.company.IndustryName }}</p>
          </div>
        </div>

        <!-- 總行標籤 -->
        <div class="tags-section" v-if="splitHqTags && splitHqTags.length > 0">
          <h3 class="section-title"><i class="el-icon-collection-tag"></i> 總行標籤 ({{ splitHqTags.length }})</h3>
          <div class="tags-container">
            <el-tag v-for="(tag, index) in splitHqTags" :key="`hq-${index}`" type="success" size="medium" class="tag-item">
              <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '總行標籤')" style="color:#409EFF;text-decoration:underline;">{{ tag.name }}</a>
            </el-tag>
          </div>
        </div>

        <!-- 自訂標籤 -->
        <div class="tags-section" v-if="splitBrTags && splitBrTags.length > 0">
          <h3 class="section-title"><i class="el-icon-collection"></i> 自訂標籤 ({{ splitBrTags.length }})</h3>
          <div class="tags-container">
            <el-tag v-for="(tag, index) in splitBrTags" :key="`br-${index}`" type="success" size="medium" class="tag-item">
              <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '自訂標籤')" style="color:#409EFF;text-decoration:underline;">{{ tag.name }}</a>
            </el-tag>
          </div>
        </div>

        <!-- 標準標籤 -->
        <div class="tags-section" v-if="splitStdTags && splitStdTags.length > 0">
          <h3 class="section-title"><i class="el-icon-collection-tag"></i> 標準標籤 ({{ splitStdTags.length }})</h3>
          <div class="tags-container">
            <el-tag v-for="(tag, index) in splitStdTags" :key="`std-${index}`" type="success" size="medium" class="tag-item">
              <a v-if="tag.isHyperLink" href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '標準標籤')" style="color:#409EFF;text-decoration:underline;">{{ tag.name }}</a>
              <span v-else>{{ tag.name }}</span>
            </el-tag>
          </div>
        </div>

        <div v-if="(!splitBrTags || splitBrTags.length === 0) && (!splitHqTags || splitHqTags.length === 0)" class="no-tags-message">
          <el-empty description="此公司暫無標籤資訊" />
        </div>

        <div class="tag-actions" v-if="btnAdvFuncVisible">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddTagDialog">新增標籤</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- ══════════════════════════════════════════════════════
         以下 Dialogs 完整保留（與桌面版相同）
         ══════════════════════════════════════════════════════ -->

    <!-- 距離搜尋 -->
    <el-dialog title="尋找附近潛在客戶" :visible.sync="showDistanceDialog" width="30%" center>
      <div>
        <label>請輸入距離（公里）：</label>
        <el-input-number v-model="searchDistance" :min="1" :max="20" style="margin-left:0.5rem;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDistanceSearch">確定</el-button>
        <el-button @click="cancelDistanceSearch">取消</el-button>
      </span>
    </el-dialog>

    <!-- 熱門標籤 -->
    <el-dialog title="熱門標籤" :visible.sync="showTagCloud" width="60%" center>
      <div class="dialogBox">
                <div style="text-align: center;color: #FF0000;">
                    <h2>請點選以下的文字</h2>
                </div>                
                <div style="cursor: pointer;">
                    <wordcloud
                        :data="hotTagsList"
                        nameKey="TagName"
                        valueKey="Weight"
                        :rotate="rotateText"
                        :color="myColors"
                        :showTooltip="false"
                        :wordClick="wordClickHandler"
                        :fontSize="[20, 30]"
                        :fontSizeRatio="1.2"
                        :padding="20">
                    </wordcloud>
                </div>
      </div>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
      <span slot="footer">
        <el-button type="primary" @click="showTagCloud = false">關閉</el-button>
      </span>      
      <!-- <span slot="footer" >
        <el-button type="danger" @click="showTagCloud = false">
          <font-awesome-icon icon="times" style="margin-right:0.5rem;" />關閉
        </el-button>
      </span> -->
    </el-dialog>

    <!-- 新增潛在客戶 -->
    <el-dialog title="新增潛在客戶" :visible.sync="showCustomer" width="90%" center>
      <div class="dialogBox">
        <h2>公司名稱: {{ addCustomer.ComName }}</h2>
        <hr />
        <label>專案名稱：</label>
        <el-select v-model="selectedProjectName" placeholder="請選擇分類" no-data-text="無數據" @change="getDeptList">
          <el-option label="請選擇" value=""></el-option>
          <el-option :label="item.ProjectName" :value="item.ID" v-for="item in ProjectNameList" :key="item.ID" />
        </el-select>
        <el-dropdown trigger="click" style="margin-left:16px;" @command="handleProjectName">
          <el-button type="primary">
            <font-awesome-icon icon="cog" style="margin:auto 8px;" />操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="add"><font-awesome-icon icon="plus" style="margin-right:8px;" />新增專案名稱</el-dropdown-item>
            <el-dropdown-item command="edit"><font-awesome-icon icon="edit" style="margin-right:8px;" />修改專案名稱</el-dropdown-item>
            <el-dropdown-item command="delete"><font-awesome-icon icon="trash" style="margin-right:8px;" />刪除專案名稱</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="btnAdvFuncVisible" type="primary" @click="saveCustomer()">
          <font-awesome-icon icon="plus" style="margin-right:5px;" />新增
        </el-button>
        <el-button type="danger" @click="showCustomer = false">
          <font-awesome-icon icon="times" style="margin-right:5px;" />關閉
        </el-button>
      </span>
    </el-dialog>

    <!-- 新增標籤 -->
    <el-dialog title="新增標籤" :visible.sync="showAddTagDialog" width="90%" center>
      <div class="tag-form">
        <div class="form-item">
          <label>公司名稱</label>
          <div class="company-name">{{ selectedCompanyTags.company ? selectedCompanyTags.company.Branch : '請先選擇公司' }}</div>
        </div>
        <div class="form-item" v-if="newTagForm.type === 'hq'">
          <label>標籤類型</label>
          <el-radio-group v-model="newTagFormType">
            <el-radio label="hq">總行標籤</el-radio>
            <el-radio label="br">自訂標籤</el-radio>
          </el-radio-group>
        </div>
        <div class="form-item">
          <label>標籤內容（多個標籤用逗號隔開）</label>
          <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="btnAdvFuncVisible" type="primary" @click="saveNewTag">儲存</el-button>
        <el-button @click="showAddTagDialog = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 自訂資本額 -->
    <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="90%" center>
      <el-form label-width="90px">
        <el-form-item label="起始金額">
          <el-input v-model="customCapital.start" placeholder="萬元" type="number"><template slot="append">萬元</template></el-input>
        </el-form-item>
        <el-form-item label="結束金額">
          <el-input v-model="customCapital.end" placeholder="萬元" type="number"><template slot="append">萬元</template></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmCustomCapital">確定</el-button>
        <el-button type="danger" @click="showCustomCapital = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 自訂設立日期 -->
    <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="90%" center>
      <el-form label-width="90px">
        <el-form-item label="起始年限">
          <el-input v-model="customYear.start" placeholder="年" type="number"><template slot="append">年</template></el-input>
        </el-form-item>
        <el-form-item label="結束年限">
          <el-input v-model="customYear.end" placeholder="年" type="number"><template slot="append">年</template></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmCustomYear">確定</el-button>
        <el-button type="danger" @click="showCustomYear = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// ── 第三方元件 ──────────────────────────────────────────────
import wordcloud from 'vue-wordcloud';
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';

// ── 自製元件（路徑相對於 mobile/ctm/ 往上 3 層）
import PageBrief from '../../../components/PageBrief.vue';
import DistSelection from '../../../components/DistSelection.vue';
import IndusCodeSelection from '../../../components/IndusCodeSelection.vue';

// ── 工具 ────────────────────────────────────────────────────
import { notify, handleError } from '../../../utils/notify';

export default {
  name: 'MobileCtmMap',

  components: {
    PageBrief,
    DistSelection,
    IndusCodeSelection,
    wordcloud,
  },

  data() {
    return {
      // ── 行動版專屬：頂部可收合搜尋列 ──────────────────────
      searchExpanded: false,

      // ── 以下與桌面版 ctmMap.vue 完全相同 ──────────────────
      btnAdvFuncVisible: false,
      userInfo: {},
      newTagFormType: 'br',

      // 右側結果列表抽屜（iPad: 60% ≈ 614px，桌面版: 30%）
      drawerVisible: false,
      drawerWidth: '33.333%',
      mapInitialized: false,

      showSaveSearch: false,
      showLoadSearch: false,
      ssName: '',
      ssDesc: '',
      selSaveSearch: '',
      saveSearchList: [],
      lstLoadQuery: [],
      lssDesc: '',

      // 左側標籤抽屜（iPad: 45%）
      tagDrawerVisible: false,
      tagDrawerWidth: '30%',
      selectedCompanyTags: { company: null, br_tags: [], hq_tags: [] },
      splitStdTags: [],

      selectedComStatus: '全部',
      selectedOrgType: '全部',
      selectedComType: '全部',

      showAddTagDialog: false,
      newTagForm: { content: '', type: 'br' },

      deptInfo: {},

      // 地圖相關
      mapObj: null,
      tbbBranch: [],
      keelungCx: [],
      latitude: 24.9895,
      longitude: 121.5080,
      zoomDegree: 16,
      theMarkerList: [],
      activeMarker: null,
      branchLatitude: null,
      branchLongitude: null,
      mapConfig: {
        tileLayerUrl: process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg',
        minZoom: 10,
        maxZoom: 16,
        defaultCenter: [24.9895, 121.5080],
        defaultZoom: 10,
        orangeIcon: null,
        redIcon: null,
        numberIcons: {},
      },

      preciseTagMappings: [
        { key: 'invest_area', title: '對外投資' },
        { key: 'is_china_fund', title: '陸資來台投資' },
        { key: 'is_invest_china', title: '赴中國大陸投資' },
        { key: 'award_name', title: '獲獎記錄' },
        { key: 'certification', title: '專業認證' },
        { key: 'domain_name', title: '企業領域' },
        { key: 'brand_name', title: '品牌商標' },
        { key: 'park_name', title: '所在園區' },
        { key: 'alarm_item', title: '裁罰警示' },
        { key: 'industry', title: '相關產業' },
        { key: 'industry_type', title: '相關產業' },
        { key: 'product', title: '相關產品' },
        { key: 'hq_category', title: '總行標籤' },
        { key: 'br_category', title: '自訂標籤' },
        { key: 'company_type', title: '公司類別' },
        { key: 'is_import', title: '進口廠商' },
        { key: 'is_export', title: '出口廠商' },
        { key: 'is_supplier', title: '合格供應商' },
        { key: 'import_value', title: '進口實績' },
        { key: 'export_value', title: '出口實績' },
      ],

      queryConditions: {
        keyword: '',
        companyStatus: [],
        companyType: [],
        orgType: [],
        isCustomer: false,
        isInvoice: false,
        isImport: false,
        isExport: false,
        isFactory: false,
        capital: { start: '', end: '', range: '' },
        setupDate: { range: '', start: '', end: '', rangeValue: '' },
        industryCode: [],
        preciseTags: [],
        location: { area: '', city: '', district: '' },
        geolocation: { Latitude: '', Longitude: '', Distance: '' },
      },
      queryConditionMap: new Map(),

      lstQuery: [],
      listQuery: { comLoc: '臺北市', SearchText: '', Page_Size: 10, Page_Num: 1 },
      keyword: '',
      totalLists: 0,
      tabledata: [],
      selectedIndustryCode: [],

      radCap: '',
      TotCapStart: '',
      TotCapEnd: '',
      showCustomCapital: false,
      customCapital: { start: '', end: '' },
      capList: [
        { cap: '2000萬(含)以下', value: 1, start: 0, end: 2000 },
        { cap: '2001萬~3000萬(含)以下', value: 2, start: 2001, end: 3000 },
        { cap: '3001萬~8000萬(含)以下', value: 3, start: 3001, end: 8000 },
        { cap: '8001萬~1億(含)以下', value: 4, start: 8001, end: 10000 },
        { cap: '1億(不含)以上', value: 5, start: 10001, end: 999999999 },
      ],

      ProjectNameList: [],

      yearCap: '',
      showCustomYear: false,
      customYear: { start: '', end: '' },
      yearList: [
        { cap: '未滿1年', start: 0, end: 1, value: 1 },
        { cap: '1年以上-未滿3年', start: 1, end: 3, value: 2 },
        { cap: '3年以上-未滿5年', start: 3, end: 5, value: 3 },
        { cap: '5年以上-未滿10年', start: 5, end: 10, value: 4 },
        { cap: '10年(含)以上', start: 10, end: 20, value: 5 },
      ],
      btnHotTag: false,

      OrgTypeList: [
        { comType: '股份有限公司' },
        { comType: '有限公司' },
        { comType: '獨資' },
        { comType: '合夥' },
        { comType: '其他' },
      ],
      ComTypeList: [
        { comType: '上市' },
        { comType: '上櫃' },
        { comType: '興櫃' },
        { comType: '公開發行' },
      ],

      industryCode: '',
      showDistrict: false,
      selCity: '全部',
      DistList: [],

      selectedPOI: null,
      selectedProjectName: '',
      addCustomer: { ComName: '', ProjectName: '', Desc: '' },

      selectedAreaValue: ['北部', '臺北市', '全部'],

      IsImport: false,
      IsExport: false,
      IsInvoice: false,
      IsCustomer: false,
      IsFactory: false,

      myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      hotTagsList: [],
      showTagCloud: false,
      rotateText: { from: 0, to: 0, numOfOrientation: 5 },

      showCustomer: false,
      selProjectName: '',
      selectedBranch: {},
      showDistanceDialog: false,
      searchDistance: 1,
      distanceLatLng: null,
      isLocating: false,
      currentCompany: null,
    };
  },

  watch: {
    selectedPOI: {
      handler(newVal) {
        if (newVal && this.tabledata.length > 0) {
          this.drawerVisible = true;
        }
      },
      immediate: true,
    },
  },

  computed: {
    splitBrTags() {
      if (this.selectedCompanyTags.br_tags && Array.isArray(this.selectedCompanyTags.br_tags)) {
        return this.selectedCompanyTags.br_tags.filter(tag => tag && tag.name.trim().length > 0);
      }
      return [];
    },
    splitHqTags() {
      if (this.selectedCompanyTags.hq_tags && Array.isArray(this.selectedCompanyTags.hq_tags)) {
        return this.selectedCompanyTags.hq_tags.filter(tag => tag && tag.name.trim().length > 0);
      }
      return [];
    },
  },

  methods: {
    hasMapContainer() {
      return !!document.getElementById('map');
    },

    // ── 行動版專屬方法 ──────────────────────────────────────

    /** 行動版「查詢」按鈕：先收合搜尋列，再執行查詢 */
    handleMobileSearch() {
      this.searchExpanded = false;
      this.$nextTick(() => this.doSearch());
    },

    handleClearInput() {
      this.keyword = '';
    },

    updateDrawerWidth() {
      const isLandscape = window.matchMedia && window.matchMedia('(orientation: landscape)').matches;
      this.drawerWidth = isLandscape ? '25%' : '33.333%';
    },

    // ── 導覽方法（行動版：使用 router 在 app 內切換頁面） ──

    /** 企業標籤頁（桌面版用 window.open，行動版改用 router.push 到行動版子頁） */
    doshowDetail(row) {
      this.$queryRecord(this, row.Branch, 'company');
      //this.$router.push({ name: 'm-ctm-map-com', query: { unicomnm: row.UniComNm } });
      // const routeData = this.$router.resolve({
      //   name: 'm-ctm-map-com',
      //   query: { unicomnm: row.UniComNm },
      // });
      // window.open(routeData.href, '_blank');      
      const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
      window.open(url, '_blank');        

    },

    /** 公司登記資訊（行動版改用 router.push） */
    async doShowCompanyDetail(data) {
      const unicomnm = data.UniComNm;
      const comname = data.Branch;
      this.$queryRecord(this, comname, 'company');
      // this.$router.push({ name: 'm-ctm-map-com', query: { unicomnm, comname } });
      // 開啟新視窗, 顯示公司詳細資訊
      const url = `/companyDetail?comid=${unicomnm}&comname=${comname}`;
      window.open(url, '_blank');		      
    },

    /** 熱門標籤點擊：開新頁並導向行動版查詢 */
    async wordClickHandler(name) {
      this.$queryRecord && this.$queryRecord(this, name, 'tag', '總行標籤');
      this.showTagCloud = false;
      const routeData = this.$router.resolve({
        name: 'm-ctm',
        query: {
          keyword: name,
          category: 'hq_category',
          type: '總行標籤',
        },
      });
      window.open(routeData.href, '_blank');
    },

    /** 左側抽屜的標籤點擊（行動版改用 router.push） */
    handleLeftDrawerTagClick(tagStr, typeFilter) {
      this.$queryRecord(this, tagStr.name, 'tag', typeFilter);
      this.tagDrawerVisible = false;
      this.$router.push({ name: 'm-ctm', query: { keyword: tagStr.name } });
    },

    // ── 以下方法與桌面版 ctmMap.vue 完全相同 ──────────────

    yearFormat(value) {
      if (!value || value.length < 4) return '';
      return value.slice(0, 4) + '年';
    },

    getStdTags() {
      // 二元性的標籤，不需要有hyperlink
      const binaryTagKeys = ["au_company_type","au_is_import","au_is_export","au_is_factory","au_is_supplier","au_is_china_fund"];      
      let stdTags = [];
      if (this.selectedCompanyTags.company) {
        for (const key in this.selectedCompanyTags.company) {
          if (key.startsWith('au_') && this.selectedCompanyTags.company[key]) {
            this.selectedCompanyTags.company[key]?.forEach(item => {
              // let tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`;
              let tagStr = item.display_name || item.name || '';
              if (item.category === 'export_value') tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 出口 ${item.name || ''}級`;
              if (item.category === 'import_value') tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 進口 ${item.name || ''}級`;
              stdTags.push({
                  name: tagStr.trim(),
                  category: item.category || key.replace('au_', ''),
                  isHyperLink: binaryTagKeys.includes(key) ? false : true,
              });
            });
          }
        }
      }
      return stdTags;
    },

    getPreciseTagTitle(tagKey) {
      if (!tagKey) return tagKey;
      const tagInfo = this.preciseTagMappings.find(item => item.key === tagKey);
      return tagInfo ? tagInfo.title : tagKey;
    },

    buildTagDisplayText(tag, value, displayText) {
      if (displayText) return displayText;
      if (tag) {
        const title = this.getPreciseTagTitle(tag);
        if (value) return `${title}:${value}`;
        return title;
      }
      return value || '';
    },

    addQueryCondition(type, value, displayText, tag = '') {
      const resolvedDisplayText = this.buildTagDisplayText(tag, value && value.name ? value.name : value, displayText);
      if (resolvedDisplayText && !this.lstQuery.includes(resolvedDisplayText)) this.lstQuery.push(resolvedDisplayText);
      switch (type) {
        case 'keyword': this.queryConditions.keyword = value; break;
        case 'companyStatus': this.queryConditions.companyStatus = value; break;
        case 'companyType': if (!this.queryConditions.companyType.includes(value)) this.queryConditions.companyType.push(value); break;
        case 'orgType': if (!this.queryConditions.orgType.includes(value)) this.queryConditions.orgType.push(value); break;
        case 'isCustomer': this.queryConditions.isCustomer = value; break;
        case 'isInvoice': this.queryConditions.isInvoice = value; break;
        case 'isImport': this.queryConditions.isImport = value; break;
        case 'isExport': this.queryConditions.isExport = value; break;
        case 'isFactory': this.queryConditions.isFactory = value; break;
        case 'capital': this.queryConditions.capital = value; break;
        case 'setupDate': this.queryConditions.setupDate = value; break;
        case 'industryCode':
          if (!this.queryConditions.industryCode.includes(value)) this.queryConditions.industryCode.push(value); break;
        case 'preciseTag': {
          const preciseTag = value && typeof value === 'object'
            ? { category: value.category || tag, name: value.name || '' }
            : { category: tag, name: value };
          if (!preciseTag.category || !preciseTag.name) break;
          const exists = this.queryConditions.preciseTags.some(item => item.category === preciseTag.category && item.name === preciseTag.name);
          if (!exists) this.queryConditions.preciseTags.push(preciseTag);
          break;
        }
        case 'location': this.queryConditions.location = value; break;
        case 'geolocation': this.queryConditions.geolocation = value; break;
      }
      if (resolvedDisplayText) {
        this.queryConditionMap.set(resolvedDisplayText, { type, value, tag });
      }
    },

    removeQueryCondition(displayText) {
      const index = this.lstQuery.indexOf(displayText);
      if (index > -1) this.lstQuery.splice(index, 1);
      const mapping = this.queryConditionMap.get(displayText);
      if (mapping) {
        const { type, value, tag } = mapping;
        switch (type) {
          case 'keyword': this.queryConditions.keyword = ''; this.keyword = ''; break;
          case 'companyStatus': this.queryConditions.companyStatus = ''; this.selectedComStatus = '全部'; break;
          case 'companyType': { const i = this.queryConditions.companyType.indexOf(value); if (i > -1) this.queryConditions.companyType.splice(i, 1); break; }
          case 'orgType': { const i = this.queryConditions.orgType.indexOf(value); if (i > -1) this.queryConditions.orgType.splice(i, 1); break; }
          case 'isCustomer': this.queryConditions.isCustomer = false; this.IsCustomer = false; break;
          case 'isInvoice': this.queryConditions.isInvoice = false; this.IsInvoice = false; break;
          case 'isImport': this.queryConditions.isImport = false; this.IsImport = false; break;
          case 'isExport': this.queryConditions.isExport = false; this.IsExport = false; break;
          case 'isFactory': this.queryConditions.isFactory = false; this.IsFactory = false; break;
          case 'capital': this.queryConditions.capital = { start: '', end: '', range: '' }; this.TotCapStart = ''; this.TotCapEnd = ''; this.radCap = ''; break;
          case 'setupDate': this.queryConditions.setupDate = { range: '', start: '', end: '', rangeValue: '' }; this.yearCap = ''; break;
          case 'industryCode': { const i = this.queryConditions.industryCode.indexOf(value); if (i > -1) this.queryConditions.industryCode.splice(i, 1); break; }
          case 'preciseTag': {
            const preciseTag = value && typeof value === 'object'
              ? { category: value.category || tag, name: value.name || '' }
              : { category: tag, name: value };
            this.queryConditions.preciseTags = this.queryConditions.preciseTags.filter(item => !(item.category === preciseTag.category && item.name === preciseTag.name));
            break;
          }
          case 'location': this.queryConditions.location = { area: '', city: '', district: '' }; this.selectedAreaValue = ['全部', '全部']; break;
          case 'geolocation': this.queryConditions.geolocation = { Latitude: '', Longitude: '', Distance: '' }; break;
        }
        this.queryConditionMap.delete(displayText);
      }
    },

    clearAllQueryConditions() {
      this.lstQuery = [];
      this.queryConditions = {
        keyword: '', companyStatus: '', companyType: [], orgType: [],
        isCustomer: false, isInvoice: false, isImport: false, isExport: false, isFactory: false,
        capital: { start: '', end: '', range: '' },
        setupDate: { range: '', start: '', end: '', rangeValue: '' },
        industryCode: [],
        preciseTags: [],
        location: { area: '', city: '', district: '' },
        geolocation: { Latitude: '', Longitude: '', Distance: '' },
      };
      this.queryConditionMap.clear();
      this.keyword = '';
      this.selectedComStatus = '全部'; this.selectedComType = '全部'; this.selectedOrgType = '全部';
      this.IsCustomer = false; this.IsInvoice = false; this.IsImport = false; this.IsExport = false; this.IsFactory = false;
      this.TotCapStart = ''; this.TotCapEnd = ''; this.radCap = ''; this.yearCap = '';
      this.selectedIndustryCode = [];
      this.selectedAreaValue = ['全部', '全部'];
      this.listQuery.comLoc = '';
    },

    handleIndustryCodeChange(value, selectedItems) {
      if (!value || value.length === 0) return;
      const code = value[value.length - 1];
      const displayText = (selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0)
        ? (selectedItems[selectedItems.length - 1].label || code)
        : code;
      this.addQueryCondition('industryCode', code, displayText);
      this.selectedIndustryCode = [];
    },

    comStatusChangeHandler(value) {
      ['全部', '營業中', '非營業中'].forEach(tag => { if (this.lstQuery.includes(tag)) this.removeQueryCondition(tag); });
      if (value && value !== '全部') {
        const statusMap = { '營業中': ['new', 'modify'], '非營業中': ['delete'] };
        this.addQueryCondition('companyStatus', statusMap[value], value);
      }
      this.selectedComStatus = value;
    },

    comTypeChangeHandler(value) {
      if (value === '全部') {
        this.ComTypeList.forEach(item => { if (this.lstQuery.includes(item.comType)) this.removeQueryCondition(item.comType); });
      } else {
        if (this.lstQuery.includes('全部')) this.removeQueryCondition('全部');
        this.addQueryCondition('companyType', value, value);
      }
      this.selectedComType = value;
    },

    orgTypeChangeHandler(value) {
      if (value === '全部') {
        this.OrgTypeList.forEach(item => { if (this.lstQuery.includes(item.comType)) this.removeQueryCondition(item.comType); });
      } else {
        if (this.lstQuery.includes('全部')) this.removeQueryCondition('全部');
        this.addQueryCondition('orgType', value, value);
      }
      this.selectedOrgType = value;
    },

    openAddTagDialog() { this.newTagForm.content = ''; this.showAddTagDialog = true; },

    async saveNewTag() {
      if (!this.newTagForm.content.trim()) { notify.warning('請輸入標籤內容'); return; }
      if (!this.selectedCompanyTags.company) { notify.warning('未選擇公司'); this.showAddTagDialog = false; return; }
      const tagArray = this.newTagForm.content.split(',').map(t => t.trim()).filter(t => t !== '');
      const params = { UniComNm: this.selectedCompanyTags.company.UniComNm, TagValues: tagArray };
      if (this.newTagFormType === 'hq') {
        this.$api.apitags.add_hq_category_tag(params).then(() => notify({ type: 'success', title: '成功', message: '已成功新增總行標籤' })).catch(err => handleError(err, '新增總公司標籤失敗'));
      } else {
        this.$api.apitags.add_category_tag(params).then(() => notify({ type: 'success', title: '成功', message: '已成功新增自訂標籤' })).catch(err => handleError(err, '新增自訂標籤失敗'));
      }
      await this.getList();
      this.showAddTagDialog = false;
    },

    saveCustomer() {
      if (!this.selectedProjectName) { notify({ type: 'warning', title: '警告', message: '請先選擇專案名稱' }); return; }
      const qry = { UniComNm: this.addCustomer.UniComNm, ComName: this.addCustomer.ComName, ProjectID: this.selectedProjectName };
      this.$api.apipocx.pocx_create(qry).then(res => {
        if (res.statuscode === 200) { notify({ type: 'success', title: '成功', message: `已成功新增潛在客戶: ${this.addCustomer.ComName}` }); this.showCustomer = false; }
        else notify({ type: 'error', title: '失敗', message: `新增潛在客戶失敗: ${res.message}` });
      }).catch(err => handleError(err, '新增潛在客戶失敗'));
    },

    async getDeptList() { this.$store.dispatch('loadingHandler', true); this.$store.dispatch('loadingHandler', false); },

    handleProjectName(command) {
      const actions = { add: () => this.addProjectName(), edit: () => this.editProjectName(), delete: () => this.deleteProjectName() };
      if (actions[command]) actions[command]();
    },

    async addProjectName() {
      this.$prompt('請輸入新的專案名稱', '新增專案名稱', { confirmButtonText: '確定', cancelButtonText: '取消', inputPattern: /.+/, inputErrorMessage: '專案名稱不可為空' }).then(async ({ value }) => {
        try {
          const res = await this.$api.apipocxpj.pocxpj_create({ ProjectName: value.trim() });
          await this.loadProjectNameList();
          this.selectedProjectName = res.data.ID;
          notify({ title: '成功', message: `成功新增專案名稱 "${value.trim()}"`, type: 'success' });
        } catch (err) { handleError(err, '新增專案名稱失敗'); }
      }).catch(() => {});
    },

    editProjectName() {
      if (!this.selectedProjectName) { notify({ title: '警告', message: '請先選擇要修改的專案名稱', type: 'warning' }); return; }
      this.$prompt('請輸入新的專案名稱', '修改專案名稱', { confirmButtonText: '確定', cancelButtonText: '取消', inputPattern: /.+/, inputErrorMessage: '專案名稱不可為空' }).then(async ({ value }) => {
        try {
          const res = await this.$api.apipocxpj.pocxpj_update({ ID: this.selectedProjectName, ProjectName: value.trim() });
          if (res.statuscode === 200) { await this.loadProjectNameList(); notify({ title: '成功', message: `成功修改專案名稱為 "${value.trim()}"`, type: 'success' }); }
          else notify({ title: '錯誤', message: `修改失敗: ${res.message || '未知錯誤'}`, type: 'error' });
        } catch (err) { handleError(err, '修改專案名稱失敗'); }
      }).catch(() => {});
    },

    deleteProjectName() {
      if (!this.selectedProjectName) { notify({ title: '警告', message: '請先選擇要修改的專案名稱', type: 'warning' }); return; }
      const proj = this.ProjectNameList.find(item => item.ID === parseInt(this.selectedProjectName));
      this.$confirm(`確定要刪除專案名稱 "${proj.ProjectName}" 嗎?`, '刪除確認', { confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        await this.$api.apipocxpj.pocxpj_delete({ ID: this.selectedProjectName });
        const index = this.ProjectNameList.findIndex(item => item.ID === parseInt(this.selectedProjectName));
        if (index !== -1) this.ProjectNameList.splice(index, 1);
        this.$message({ type: 'success', message: '專案名稱已成功刪除' });
        this.selectedProjectName = '';
      }).catch(() => { this.$message({ type: 'info', message: '已取消刪除操作' }); });
    },

    removePreviousLocationTags() {
      const locationPatterns = ['北部','中部','南部','東部','臺北市','新北市','桃園市','臺中市','臺南市','高雄市','新竹市','新竹縣','苗栗縣','彰化縣','南投縣','雲林縣','嘉義市','嘉義縣','屏東縣','宜蘭縣','花蓮縣','臺東縣','澎湖縣','金門縣','連江縣','基隆市'];
      this.lstQuery = this.lstQuery.filter(tag => !locationPatterns.some(p => tag.includes(p)) && !/.*[市縣區鄉鎮].*/.test(tag) && !/.*市.*區/.test(tag));
    },

    handleAreaChange(values) {
      if (!values || values.length === 0) return;
      this.removePreviousLocationTags();
      if (values.length === 1) { if (values[0] !== '全部') this.lstQuery.push(values[0]); }
      else if (values.length === 2) {
        const city = values[1];
        if (city !== '全部') { this.listQuery.comLoc = city; this.addQueryCondition('location', { city, district: '' }, city); }
      } else if (values.length === 3) {
        const city = values[1]; const district = values[2];
        const txtAddress = `${city}${district}`;
        this.listQuery.comLoc = txtAddress;
        this.addQueryCondition('location', { city, district }, txtAddress);
      }
    },

    handleTagClick(itemOrTagStr, tagCategory = '', tagType = '標準標籤') {
      // 抽屜中的標籤點擊：導向 ctm（與桌面版一致）
      if (typeof itemOrTagStr === 'string') {
        const tagStr = itemOrTagStr;
        if (!tagStr) {
          return;
        }
        this.$queryRecord(this, tagStr, 'tag', tagType);
        this.tagDrawerVisible = false;
        const routeData = this.$router.resolve({
          name: 'm-ctm',
          query: {
            keyword: tagStr,
            category: tagCategory,
            type: tagType,
          },
        });
        window.open(routeData.href, '_blank');
        return;
      }

      // 結果列表「標籤」按鈕：開啟左側標籤抽屜
      const item = itemOrTagStr;
      console.log('handleTagClick - item:', item);
      if (!item) return;
      this.selectedCompanyTags = { company: item, br_tags: item.brTags || [], hq_tags: item.hqTags || [] };
      this.splitStdTags = this.getStdTags();
      this.tagDrawerVisible = true;
    },

    doshowMap(row, index) {
      if (!row.Latitude || !row.Longitude) { notify({ title: '無經緯度資料', message: `公司 ${row.Branch} 無經緯度資料`, type: 'warning' }); return; }
      this.selectedPOI = row;
      if (this.mapObj && row.Latitude && row.Longitude) {
        const infoRows = `${row.Cap ? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc ? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：' + row.RepName : ''}`;

        // 有進階功能權限（非 DO/APA/AP）：顯示三個按鈕
        const popMessage = `
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;min-width:280px;">
            <h3 style="margin:0;">${index}. ${row.Branch}</h3>
            <div style="display:flex;gap:6px;">
              <button onclick="window.handleFindNearbyCustomers('${row.Branch}',${row.Latitude},${row.Longitude})"
                style="min-width:24px;height:24px;border-radius:4px;background:#67C23A;border:none;color:white;cursor:pointer;font-size:12px;padding:0 8px;display:flex;align-items:center;justify-content:center;line-height:1;"
                title="尋找${row.Branch}附近的潛在客戶">@</button>
              <button onclick="window.handleAddPotentialCustomerClick('${row.UniComNm}','${row.Branch}',${row.Latitude},${row.Longitude})"
                style="width:24px;height:24px;border-radius:50%;background:#409EFF;border:none;color:white;cursor:pointer;font-size:12px;padding:0;display:flex;align-items:center;justify-content:center;line-height:1;"
                title="新增潛在客戶">#</button>
              <button onclick="window.handleOpenAddTagDialog('${row.UniComNm}','${row.Branch}')"
                style="width:24px;height:24px;border-radius:50%;background:#E6A23C;border:none;color:white;cursor:pointer;font-size:12px;padding:0;display:flex;align-items:center;justify-content:center;line-height:1;"
                title="新增標籤">T</button>
            </div>
          </div>${infoRows}`;

        // 無進階功能權限（DO/APA/AP）：只顯示附近搜尋按鈕
        const popMessage1 = `
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;min-width:280px;">
            <h3 style="margin:0;">${index}. ${row.Branch}</h3>
            <div style="display:flex;gap:6px;">
              <button onclick="window.handleFindNearbyCustomers('${row.Branch}',${row.Latitude},${row.Longitude})"
                style="min-width:24px;height:24px;border-radius:4px;background:#67C23A;border:none;color:white;cursor:pointer;font-size:12px;padding:0 8px;display:flex;align-items:center;justify-content:center;line-height:1;"
                title="尋找${row.Branch}附近的潛在客戶">@</button>
            </div>
          </div>${infoRows}`;

        let numberIcon = (index <= 10 && this.mapConfig.numberIcons[index]) ? this.mapConfig.numberIcons[index] : this.mapConfig.orangeIcon;
        if (this.activeMarker) this.mapObj.removeLayer(this.activeMarker);
        this.activeMarker = L.marker([row.Latitude, row.Longitude], { icon: numberIcon, zIndexOffset: 1000 }).addTo(this.mapObj);
        this.activeMarker.bindPopup(
          this.btnAdvFuncVisible ? popMessage : popMessage1,
          { maxWidth: 400, minWidth: 280, className: 'custom-popup', autoPan: true }
        ).openPopup();
        this.mapObj.flyTo([row.Latitude, row.Longitude], 15, { duration: 1.5, easeLinearity: 0.5 });
      }
      this.$nextTick(() => { this.drawerVisible = true; });
    },

    capFormat(num) {
      if (num === null) return '';
      if (num >= 100000000) return (num / 100000000).toFixed(0) + ' 億';
      return (num / 10000).toFixed(0) + ' 萬';
    },

    doSearch() {
      const newKeyword = this.keyword.trim();
      this.listQuery.Page_Num = 1;
      for (const [tag, mapping] of Array.from(this.queryConditionMap.entries())) {
        if (mapping && mapping.type === 'keyword') this.removeQueryCondition(tag);
      }
      if (newKeyword.length > 0) this.addQueryCondition('keyword', newKeyword, newKeyword);
      if (this.keyword && this.keyword.trim() !== '') this.$queryRecord(this, newKeyword, 'keyword');
      this.getList();
      if (newKeyword.length > 0) this.drawerVisible = true;
    },

    async getList() {
      if (!this.mapInitialized) { this.initialMap(); this.mapInitialized = true; }
      let qry = { Page_Size: this.listQuery.Page_Size, Page_Num: this.listQuery.Page_Num };
      if (this.queryConditions.location.city && this.queryConditions.location.city !== '全部') qry.City = this.queryConditions.location.city;
      if (this.queryConditions.location.district && this.queryConditions.location.district !== '') qry.District = this.queryConditions.location.district;
      if (this.queryConditions.keyword?.length > 0) qry.SearchText = this.queryConditions.keyword.trim().split(/\s+/);
      if (this.queryConditions.companyStatus.length > 0) {
        if (this.queryConditions.companyStatus === '營業中') qry.DataStatus = ['new', 'modify'];
        else if (this.queryConditions.companyStatus === '非營業中') qry.DataStatus = ['delete'];
      }
      if (this.queryConditions.companyType.length > 0) qry.AuComType = this.queryConditions.companyType;
      if (this.queryConditions.orgType.length > 0) qry.ComType = this.queryConditions.orgType;
      if (this.queryConditions.isCustomer) qry.IsExistingCustomer = 'Y';
      if (this.queryConditions.isInvoice) qry.HasInvoice = 'Y';
      if (this.queryConditions.isImport) qry.HasImport = 'Y';
      if (this.queryConditions.isExport) qry.HasExport = 'Y';
      if (this.queryConditions.isFactory) qry.HasFactory = 'Y';
      if (this.queryConditions.capital.range) { qry.CapMin = this.queryConditions.capital.start * 10000; qry.CapMax = this.queryConditions.capital.end * 10000; }
      if (this.queryConditions.setupDate.range) { qry.Start_Date = this.queryConditions.setupDate.start; qry.End_Date = this.queryConditions.setupDate.end; }
      if (this.queryConditions.industryCode && this.queryConditions.industryCode.length > 0) qry.IndusNm = this.queryConditions.industryCode;
      if (this.queryConditions.preciseTags && this.queryConditions.preciseTags.length > 0) {
        qry.PreciseTags = this.queryConditions.preciseTags.map(tagItem => ({
          category: tagItem.category,
          display_name: tagItem.display_name || tagItem.name,
        }));
      }
      if (this.queryConditions.geolocation.Distance.length > 0 && this.queryConditions.geolocation.Latitude && this.queryConditions.geolocation.Longitude) {
        qry.Distance = this.queryConditions.geolocation.Distance;
        qry.Latitude = this.queryConditions.geolocation.Latitude;
        qry.Longitude = this.queryConditions.geolocation.Longitude;
      }
      this.$store.dispatch('loadingHandler', true);
      try {
        const res = await this.$api.apibidmain.search_bidmain(qry);
        this.totalLists = parseInt(res.total);
        this.tabledata = res.data.map(item => ({
          UniComNm: item.UniComNm, Branch: item.ComName, ComLoc: item.ComLoc, Tel: item.Tel,
          Latitude: item.Latitude, Longitude: item.Longitude, Cap: item.Cap,
          brTags: item.br_category || [], hqTags: item.hq_category || [],
          EstDate: item.ApvDt, IndustryName: item.IndusType,
          au_company_type: item.au_company_type, au_is_import: item.au_is_import,
          au_is_export: item.au_is_export, au_is_factory: item.au_is_factory,
          au_is_supplier: item.au_is_supplier, au_is_china_fund: item.au_is_china_fund,
          au_park_name: item.au_park_name, au_is_existing_customer: item.au_is_existing_customer,
          au_import_value: item.au_import_value, au_export_value: item.au_export_value,
          au_invest_area: item.au_invest_area, au_is_invest_china: item.au_is_invest_china,
          au_award_name: item.au_award_name, au_certification: item.au_certification,
          au_domain_name: item.au_domain_name, au_alarm_item: item.au_alarm_item,
          au_phone: item.au_phone, au_mobile: item.au_mobile, au_mail: item.au_mail,
          au_industry_type: item.au_industry_type, au_product: item.au_product, au_brand_name: item.au_brand_name,
        }));
        if (res.data.length > 0 && res.data[0].Latitude && res.data[0].Longitude) { this.latitude = res.data[0].Latitude; this.longitude = res.data[0].Longitude; this.zoomDegree = 13; }
        this.groupMap();
      } catch (err) {
        handleError(err, '查詢客戶資料失敗');
      }
      this.$store.dispatch('loadingHandler', false);
      if (this.mapInitialized) this.drawerVisible = true;
    },

    async pageChange(val) { this.listQuery.Page_Num = val; await this.getList(); this.drawerVisible = true; },

    otherChangeHandler(value) {
      const conditionMap = {
        '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
        '有發票': { type: 'isInvoice', checked: this.IsInvoice },
        '有進口': { type: 'isImport', checked: this.IsImport },
        '有出口': { type: 'isExport', checked: this.IsExport },
        '有工廠': { type: 'isFactory', checked: this.IsFactory },
      };
      const condition = conditionMap[value];
      if (condition) { if (condition.checked) this.addQueryCondition(condition.type, true, value); else this.removeQueryCondition(value); }
    },

    handleClose(tag) { this.removeQueryCondition(tag); },

    doClearTags() {
      // 保持與桌面版 ctmMap.vue 行為一致：完整重置所有查詢條件與地圖相關暫存
      this.selectedIndustryCode = [];
      this.clearAllQueryConditions();
      this.selectedAreaValue = [];

      this.selectedTagsList = [];
      this.tags = [];

      if (typeof this.removePreviousLocationTags === 'function') {
        this.removePreviousLocationTags();
      }
    },

    radClick(val) {
      if (val === 'custom') { this.showCustomCapital = true; return; }
      const capInfo = this.capList.find(x => x.value === val);
      this.capList.forEach(cap => { if (this.lstQuery.includes(cap.cap)) this.removeQueryCondition(cap.cap); });
      this.addQueryCondition('capital', { start: capInfo.start, end: capInfo.end, range: capInfo.cap }, capInfo.cap);
      this.radCap = val;
    },

    confirmCustomCapital() {
      const start = parseFloat(this.customCapital.start); const end = parseFloat(this.customCapital.end);
      if (!start || !end) { notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' }); return; }
      if (start >= end) { notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' }); return; }
      this.capList.forEach(cap => { if (this.lstQuery.includes(cap.cap)) this.removeQueryCondition(cap.cap); });
      this.lstQuery.filter(tag => tag.includes('萬~') && tag.includes('萬')).forEach(tag => this.removeQueryCondition(tag));
      const displayText = `${start}萬~${end}萬`;
      this.addQueryCondition('capital', { start, end, range: displayText }, displayText);
      this.customCapital.start = ''; this.customCapital.end = '';
      this.showCustomCapital = false;
      notify({ type: 'success', title: '成功', message: `已設定資本額區間：${displayText}` });
    },

    yearClick(val) {
      if (val === 'custom') { this.showCustomYear = true; return; }
      const yearInfo = this.yearList.find(x => x.value === val);
      const currentYear = new Date().getFullYear();
      const startDate = `${currentYear - yearInfo.end}-01-01`;
      const endDate = `${currentYear - yearInfo.start}-12-31`;
      this.yearList.forEach(year => { if (this.lstQuery.includes(year.cap)) this.removeQueryCondition(year.cap); });
      this.addQueryCondition('setupDate', { range: yearInfo.cap, start: startDate, end: endDate, rangeValue: val }, yearInfo.cap);
      this.yearCap = val;
    },

    confirmCustomYear() {
      const start = parseFloat(this.customYear.start); const end = parseFloat(this.customYear.end);
      if (!start || !end) { notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' }); return; }
      if (start >= end) { notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' }); return; }
      this.yearList.forEach(year => { if (this.lstQuery.includes(year.cap)) this.removeQueryCondition(year.cap); });
      this.lstQuery.filter(tag => tag.includes('年~') && tag.includes('年')).forEach(tag => this.removeQueryCondition(tag));
      const displayText = `${start}年~${end}年`;
      const currentYear = new Date().getFullYear();
      this.addQueryCondition('setupDate', { range: displayText, start: `${currentYear - end}-01-01`, end: `${currentYear - start}-12-31`, rangeValue: 'custom' }, displayText);
      this.customYear.start = ''; this.customYear.end = '';
      this.showCustomYear = false;
      notify({ type: 'success', title: '成功', message: `已設定設立日期區間：${displayText}` });
    },

    doTagsCloud() { this.loadHotTags(); this.showTagCloud = true; },

    loadHotTags() {
      this.$api.apihottags.getAllHotTags({ isSys: true }).then(res => {
        this.hotTagsList = Array.isArray(res.data) ? res.data : [];
        // 第 11 筆作為功能開關；前 10 筆才是實際顯示的熱門標籤
        const enabledHotTags = this.hotTagsList[10];
        console.log('第11個熱門標籤（用於控制按鈕顯示）:', enabledHotTags);
        this.btnHotTag = !!(enabledHotTags && enabledHotTags.TagName === 'Y');
        console.log('熱門標籤顯示狀態:', this.btnHotTag);

        this.hotTagsList = this.hotTagsList.slice(0, 10);
        const maxWeight = 20;
        this.hotTagsList.forEach((tag, index) => {
          tag.Weight = Math.max(1, Math.round(Math.log(maxWeight - index + 1)));
        });
      }, err => handleError(err, '取得熱門標籤失敗'));
    },

    initialMap() {
      if (!this.hasMapContainer()) return;
      if (this.mapInitialized && this.mapObj) { this.mapObj.setView([this.latitude, this.longitude], this.zoomDegree); return; }
      const defaultIcon = new L.Icon({ iconUrl: '/markericons/marker-icon-2x-orange.png', shadowUrl: '/markericons/marker-shadow.png', iconSize: [20, 33], iconAnchor: [10, 33], popupAnchor: [1, -30], shadowSize: [33, 33] });
      const redIcon = new L.Icon({ iconUrl: '/markericons/marker-icon-2x-red.png', shadowUrl: '/markericons/marker-shadow.png', iconSize: [20, 33], iconAnchor: [10, 33], popupAnchor: [1, -30], shadowSize: [33, 33] });
      this.mapConfig.orangeIcon = defaultIcon;
      this.mapConfig.redIcon = redIcon;

      // 預載 1~10 序號圖示（與桌面版一致）
      for (let i = 1; i <= 10; i++) {
        this.mapConfig.numberIcons[i] = new L.Icon({ iconUrl: `/markericons/${i}.png`, shadowUrl: '/markericons/marker-shadow.png', iconSize: [20, 33], iconAnchor: [10, 33], popupAnchor: [1, -30], shadowSize: [33, 33] });
      }

      const map = L.map('map', {
        attributionControl: false,
        contextmenu: true,
        contextmenuWidth: 180,
        contextmenuItems: [{ text: '尋找?公里內的潛在客戶', callback: (e) => this.onFindNearbyCustomers(e) }],
      }).setView([this.latitude, this.longitude], this.mapConfig.defaultZoom);
      L.tileLayer(this.mapConfig.tileLayerUrl, { minZoom: this.mapConfig.minZoom, maxZoom: this.mapConfig.maxZoom, attribution: '' }).addTo(map);
      const markers = new L.markerClusterGroup();
      map.addLayer(markers);
      map.setView([this.latitude, this.longitude], this.zoomDegree);
      this.mapObj = map;
      setTimeout(() => { if (this.mapObj) { this.mapObj.invalidateSize(); this.mapInitialized = true; } }, 300);
    },

    groupMap() {
      if (!this.hasMapContainer()) return;
      if (!this.mapObj) {
        this.initialMap();
        if (!this.mapObj) return;
      }

      const defaultIcon = new L.Icon({ iconUrl: '/markericons/marker-icon-2x-orange.png', shadowUrl: '/markericons/marker-shadow.png', iconSize: [20, 33], iconAnchor: [10, 33], popupAnchor: [1, -30], shadowSize: [33, 33] });
      if (this.mapObj && this.mapObj.remove) {
        this.mapObj.remove();
      }
      this.mapObj = L.map('map', {
        attributionControl: false,
        contextmenu: true, contextmenuWidth: 180,
        contextmenuItems: [{ text: '尋找?公里內的潛在客戶', callback: (e) => this.onFindNearbyCustomers(e) }],
      }).setView([this.latitude, this.longitude], this.zoomDegree);
      L.tileLayer(process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg', { minZoom: 10, maxZoom: 16, attribution: '' }).addTo(this.mapObj);
      const markers = new L.markerClusterGroup().addTo(this.mapObj);
      const endIndex = Math.min(this.tabledata.length, this.listQuery.Page_Size || 10);
      for (let i = 0; i < endIndex; i++) {
        const row = this.tabledata[i]; const index = i + 1;
        const lat = row.Latitude; const lng = row.Longitude;
        if (!lat || !lng) continue;
        const popMessage = `<div style="min-width:260px;"><h3 style="margin:0 0 8px;">${index}. ${row.Branch}</h3>${row.Cap ? '<br>資本額：' + this.capFormat(row.Cap) : ''}${row.ComLoc ? '<br>地址：' + row.ComLoc : ''}${row.Tel ? '<br>電話：' + row.Tel : ''}${row.RepName ? '<br>負責人：' + row.RepName : ''}</div>`;
        const numberIcon = (index <= 10 && this.mapConfig.numberIcons[index]) ? this.mapConfig.numberIcons[index] : defaultIcon;
        markers.addLayer(L.marker([lat, lng], { icon: numberIcon }).bindPopup(popMessage));
      }
      setTimeout(() => { if (this.mapObj) this.mapObj.invalidateSize(); }, 300);
    },

    onFindNearbyCustomers(e) { this.showDistanceDialog = true; this.distanceLatLng = e.latlng; if (this.mapObj) this.mapObj.closePopup(); },

    async confirmDistanceSearch() {
      if (!this.distanceLatLng?.lat || !this.distanceLatLng?.lng) { notify({ title: '錯誤', message: '無法取得搜尋座標，請重新選擇位置', type: 'error' }); this.showDistanceDialog = false; return; }
      this.clearAllQueryConditions();
      this.selectedAreaValue = ['全部', '全部'];  // 清空區域選擇（非常重要！）
      this.queryConditions.geolocation = { Latitude: this.distanceLatLng.lat, Longitude: this.distanceLatLng.lng, Distance: this.searchDistance + 'km' };
      this.addQueryCondition('geolocation', this.queryConditions.geolocation, `距離${this.queryConditions.geolocation.Distance}內`);
      this.addQueryCondition('capital', { start: 1001, end: 9999999, range: '1千萬(不含)以上' }, '1千萬(不含)以上');
      await this.getList();
      this.showDistanceDialog = false;
    },

    cancelDistanceSearch() { this.showDistanceDialog = false; },

    async handleLocationClick() {
      if (this.isLocating) return;
      try { this.isLocating = true; await this.getUserLocation(); } catch (e) { console.error('定位失敗:', e); } finally { this.isLocating = false; }
    },

    getUserLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) { notify({ title: '瀏覽器不支援', message: '您的瀏覽器不支援地理位置功能', type: 'error' }); reject(new Error('不支援地理位置')); return; }
        navigator.geolocation.getCurrentPosition(
          pos => { this.handleLocationSuccess(pos); resolve(pos); },
          () => this.tryHighAccuracyLocation().then(resolve).catch(reject),
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 },
        );
      });
    },

    tryHighAccuracyLocation() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          pos => { this.handleLocationSuccess(pos); resolve(pos); },
          err => { this.handleLocationError(err); reject(err); },
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
        );
      });
    },

    handleLocationSuccess(position) {
      this.latitude = position.coords.latitude; this.longitude = position.coords.longitude;
      if (this.mapObj) {
        this.mapObj.setView([this.latitude, this.longitude], 14);
        const userIcon = new L.Icon({ iconUrl: '/markericons/marker-icon-2x-blue.png', shadowUrl: '/markericons/marker-shadow.png', iconSize: [20, 33], iconAnchor: [10, 33], popupAnchor: [1, -30], shadowSize: [33, 33] });
        const userPopup = `
          <div style="display:flex;align-items:center;min-width:160px;gap:8px;">
            <div style="font-weight:700;font-size:16px;color:#303133;">您的位置</div>
            <button onclick="window.handleFindNearbyCustomers('我的位置',${this.latitude},${this.longitude})"
              style="margin-left:auto;width:28px;height:28px;border-radius:50%;background:#409EFF;border:none;color:white;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;"
              title="尋找附近潛在客戶">@</button>
          </div>`;
        L.marker([this.latitude, this.longitude], { icon: userIcon }).addTo(this.mapObj).bindPopup(userPopup).openPopup();
      }
      notify({ title: '位置獲取成功', message: `已定位至您的當前位置 (${position.coords.latitude.toFixed(4)}, ${position.coords.longitude.toFixed(4)})`, type: 'success' });
    },

    handleLocationError(error) {
      const msgMap = { [error.PERMISSION_DENIED]: '位置服務已被拒絕，請在瀏覽器設定中允許位置存取', [error.POSITION_UNAVAILABLE]: '位置信息不可用，請檢查GPS是否開啟', [error.TIMEOUT]: '獲取位置超時，請確保GPS信號良好並重試' };
      notify({ title: '位置獲取失敗', message: msgMap[error.code] || `定位失敗：${error.message || '未知錯誤'}`, type: error.code === error.PERMISSION_DENIED ? 'error' : 'warning' });
    },

    handleFindNearbyCustomers(branch, latitude, longitude) {
      this.distanceLatLng = { lat: latitude, lng: longitude };
      this.currentCompany = { branch, latitude, longitude };
      this.showDistanceDialog = true;
    },

    handleAddPotentialCustomerClick(uniComNm, branch) {
      this.addCustomer = this.selectedPOI ? { ComName: this.selectedPOI.Branch, UniComNm: this.selectedPOI.UniComNm } : { ComName: branch, UniComNm: uniComNm };
      this.showCustomer = true;
    },

    getRoutePayload() {
      return {
        ...(this.$route.query || {}),
        ...(this.$route.params || {}),
      };
    },

    focusCompanyByRoute(payload) {
      if (!this.tabledata || this.tabledata.length === 0) return;

      const targetLat = parseFloat(payload.lat);
      const targetLng = parseFloat(payload.lng);
      const hasTargetLatLng = Number.isFinite(targetLat) && Number.isFinite(targetLng);

      let targetIndex = -1;
      if (payload.unicomnm) {
        targetIndex = this.tabledata.findIndex(item => item.UniComNm === payload.unicomnm);
      }
      if (targetIndex === -1 && payload.comname) {
        targetIndex = this.tabledata.findIndex(item => item.Branch === payload.comname);
      }
      if (targetIndex === -1 && hasTargetLatLng) {
        const epsilon = 0.00001;
        targetIndex = this.tabledata.findIndex(item => {
          const lat = parseFloat(item.Latitude);
          const lng = parseFloat(item.Longitude);
          return Number.isFinite(lat)
            && Number.isFinite(lng)
            && Math.abs(lat - targetLat) <= epsilon
            && Math.abs(lng - targetLng) <= epsilon;
        });
      }

      if (targetIndex > -1) {
        this.$nextTick(() => this.doshowMap(this.tabledata[targetIndex], targetIndex + 1));
      } else if (hasTargetLatLng && this.mapObj) {
        this.mapObj.flyTo([targetLat, targetLng], 15, { duration: 1.5, easeLinearity: 0.5 });
      }
    },

    loadProjectNameList() {
      if (!this.btnAdvFuncVisible) return;
      this.$api.apipocxpj.pocxpj_search({ Page_Num: 1, Page_Size: 20 }).then(res => { this.ProjectNameList = res.data; }).catch(() => notify({ title: '錯誤', message: '獲取專案名稱失敗', type: 'error' }));
    },

    async getFunctions() {
      this.userInfo = this.$store.state.userInfo;
      if (this.userInfo && this.userInfo.Role) {
        const role = this.userInfo.Role[0].toLowerCase();
        if (['he','hd','hc','hc1'].includes(role)) this.newTagForm.type = 'hq';
        this.btnAdvFuncVisible = !['do','apa','ap'].includes(role);
      }
    },

    async getBranchDist() {
      const { branchArea, branchCity, branchDist } = this.$store.state;
        
        // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
        if (branchArea && branchCity) {
            if (branchDist) {
                this.selectedAreaValue = [branchArea, branchCity, branchDist];
            } else {
                this.selectedAreaValue = [branchArea, branchCity];
            }
            console.log("設定分行所在地區:", this.selectedAreaValue);
            
            // 等待子組件完成初始化
            await this.$nextTick();
            this.handleAreaChange(this.selectedAreaValue);
        }
    },

    rebuildFromQueryConditions(conditions) {
      this.lstQuery = []; this.queryConditionMap.clear();
      if (!conditions) return;
      if (conditions.keyword) { this.lstQuery.push(conditions.keyword); this.queryConditionMap.set(conditions.keyword, { type: 'keyword', value: conditions.keyword }); this.keyword = conditions.keyword; }
      if (conditions.isCustomer) { this.lstQuery.push('既有客戶'); this.queryConditionMap.set('既有客戶', { type: 'isCustomer', value: true }); this.IsCustomer = true; }
      if (conditions.isInvoice) { this.lstQuery.push('有發票'); this.queryConditionMap.set('有發票', { type: 'isInvoice', value: true }); this.IsInvoice = true; }
      if (conditions.isImport) { this.lstQuery.push('有進口'); this.queryConditionMap.set('有進口', { type: 'isImport', value: true }); this.IsImport = true; }
      if (conditions.isExport) { this.lstQuery.push('有出口'); this.queryConditionMap.set('有出口', { type: 'isExport', value: true }); this.IsExport = true; }
      if (conditions.isFactory) { this.lstQuery.push('有工廠'); this.queryConditionMap.set('有工廠', { type: 'isFactory', value: true }); this.IsFactory = true; }
      if (conditions.capital?.range) { this.lstQuery.push(conditions.capital.range); this.queryConditionMap.set(conditions.capital.range, { type: 'capital', value: conditions.capital }); }
      if (conditions.setupDate?.range) { this.lstQuery.push(conditions.setupDate.range); this.queryConditionMap.set(conditions.setupDate.range, { type: 'setupDate', value: conditions.setupDate }); }
      if (Array.isArray(conditions.preciseTags)) {
        conditions.preciseTags.forEach(tagItem => {
          if (!tagItem || !tagItem.name) return;
          this.addQueryCondition('preciseTag', { category: tagItem.category || '', name: tagItem.name }, '', tagItem.category || '');
        });
      }
      if (conditions.location && (conditions.location.city || conditions.location.district)) {
        const locationText = `${conditions.location.city || ''}${conditions.location.district || ''}`;
        this.lstQuery.push(locationText); this.queryConditionMap.set(locationText, { type: 'location', value: conditions.location });
        const { area: _area, city: _city, district: _dist } = conditions.location;
        this.selectedAreaValue = _dist ? [_area || '全部', _city, _dist] : _city ? [_area || '全部', _city] : [_area || '全部'];
      }
    },

    async getPreferences() {
      const funs = this.$store.getters.userInfo;
      let deptInfo = {};
      const qry = { Page_Num: 1, Page_Size: 1, DeptID: funs.DeptID,isSys: true };
      // 如果是HD及HC角色, 在分行資訊中沒有資料, 所以直接用010營業部的資料來顯示地圖, 但不帶入其他搜尋條件
      if( funs && (funs.Role[0].toLowerCase()=='hd' || funs.Role[0].toLowerCase()=='hc' || funs.Role[0].toLowerCase()=='hc1') ) {
        qry.DeptID = "999";   
      }
      console.log("讀取偏好設定參數",qry);    
      await this.$api.apidivison.division_info_list(qry).then( res => {
          console.log("division_info_list API 結果:",res);
          if( res.total == 0) {     
              return;
          }
          if( res.total == 1) {
              // 保存分行坐標
              deptInfo = res.data[0];
              console.log("分行資料:", deptInfo);
              
              // 明確檢查坐標是否存在並轉換為數字
              if (deptInfo.Latitude !== null && deptInfo.Latitude !== undefined && 
                  deptInfo.Longitude !== null && deptInfo.Longitude !== undefined) {
                  this.branchLatitude = parseFloat(deptInfo.Latitude);
                  this.branchLongitude = parseFloat(deptInfo.Longitude);
                  console.log("✅ 已讀取分行坐標", { 
                      lat: this.branchLatitude, 
                      lng: this.branchLongitude,
                      原始Lat: deptInfo.Latitude,
                      原始Lng: deptInfo.Longitude
                  });
              } else {
                  console.warn("❌ 分行資料中沒有有效的坐標", { Latitude: deptInfo.Latitude, Longitude: deptInfo.Longitude });
              }
              
              // 2026-03-11, 地圖不再讀取偏好設定中的 Parameters 欄位, 直接用所在地區的設定來顯示地圖, 以避免因為偏好設定中的條件過於複雜, 而無法正確解析出地區資訊, 導致地圖無法顯示
              this.getBranchDist();
              // 讀取 Parameters 欄位，並解析成物件                
              // const paramsStr = deptInfo.Parameters;
              // if( paramsStr ) {
              //   const qc = JSON.parse(paramsStr);
              //   this.queryConditions = qc; 
              //   this.rebuildFromQueryConditions(qc);
              // }
              // else {
              //     console.warn('division_info 偏好設定中沒有 Parameters 欄位');
              //     // 若沒有 Parameters，則用所在地區, 
              //     this.getBranchDist();
              // }
          }                
      }).catch( err => {
          console.log("❌ getPreferences API 錯誤:", err);
      });   
      return deptInfo;    
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.updateDrawerWidth);
    if (this._resizeListenerAdded) window.removeEventListener('resize', this.updateToggleButtonPosition);
    ['handleAddPotentialCustomerClick', 'handleFindNearbyCustomers', 'handleOpenAddTagDialog'].forEach(fn => { if (window[fn]) delete window[fn]; });
    if (this.mapObj && this.mapObj.remove) {
      this.mapObj.remove();
      this.mapObj = null;
    }
  },

  async mounted() {
    await this.getFunctions();
    this.loadHotTags();
    this.loadProjectNameList();
    this.updateDrawerWidth();
    window.addEventListener('resize', this.updateDrawerWidth);
    window.handleAddPotentialCustomerClick = this.handleAddPotentialCustomerClick;
    window.handleFindNearbyCustomers = this.handleFindNearbyCustomers;
    window.handleOpenAddTagDialog = (uniComNm, branch) => {
      this.selectedCompanyTags.company = { UniComNm: uniComNm, Branch: branch };
      this.showAddTagDialog = true;
    };
    this.initialMap();
    this.mapInitialized = true;

    const routePayload = this.getRoutePayload();
    if (routePayload?.searchmode === 'exact') {
      this.clearAllQueryConditions();
      if (routePayload.comname) {
        this.keyword = routePayload.comname;
        this.addQueryCondition('keyword', routePayload.comname, routePayload.comname);
      }
      const exactLat = parseFloat(routePayload.lat);
      const exactLng = parseFloat(routePayload.lng);
      if (Number.isFinite(exactLat) && Number.isFinite(exactLng)) {
        this.latitude = exactLat;
        this.longitude = exactLng;
      }
      await this.getList();
      this.focusCompanyByRoute(routePayload);
    } else if (routePayload?.comname) {
      this.clearAllQueryConditions();
      if (routePayload.comname) { this.keyword = routePayload.comname; this.addQueryCondition('keyword', routePayload.comname, routePayload.comname); }
      if (routePayload.lng && routePayload.lat) {
        this.latitude = routePayload.lat; this.longitude = routePayload.lng;
        this.addQueryCondition('geolocation', { Latitude: routePayload.lat, Longitude: routePayload.lng, Distance: '10km' }, '距離10km內');
      }
      if (routePayload.indusNum) this.addQueryCondition('industryCode', routePayload.indusNum, routePayload.indusNum);
      this.addQueryCondition('capital', { start: '1000', end: '999999', range: '1千萬以上' }, '1千萬以上');
    } else {
      let showBranch = false;
      this.defpInfo = await this.getPreferences();
      await this.$nextTick();
      if (this.branchLatitude && this.branchLongitude && this.mapObj) {
        this.latitude = this.branchLatitude; this.longitude = this.branchLongitude; showBranch = true;
      }
      await this.getList();
      if (showBranch && this.mapObj) {
        this.mapObj.setView([this.branchLatitude, this.branchLongitude], 12);
        this.activeMarker = L.marker([this.branchLatitude, this.branchLongitude], { icon: this.mapConfig.redIcon, zIndexOffset: 1000 }).addTo(this.mapObj);
        this.activeMarker.bindPopup(`<div style="min-width:260px;"><h3 style="margin:0;">${this.defpInfo.BranchFullName}</h3>${this.defpInfo.Address ? '<br>地址：' + this.defpInfo.Address : ''}</div>`, { maxWidth: 350, minWidth: 260, className: 'custom-popup', autoPan: true }).openPopup();
      }
    }
    if (this.mapObj) this.mapObj.setView([this.latitude, this.longitude], this.zoomDegree);
  },
};
</script>

<style lang="scss" scoped>
// ── 版面 ─────────────────────────────────────────────────────
.m-map-page {
  position: relative;
  width: 100%;
  height: 100%;           // MobileHome 的 .m-content 提供高度
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #000;
}

// 地圖容器佔滿搜尋列以下區域
.m-map-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;

  // leaflet 地圖本身（#map 由 Leaflet 接管大小）
  &#map { width: 100%; height: 100%; }
}

// ── 搜尋列（可收合） ────────────────────────────────────────
.m-search-bar {
  position: relative;
  z-index: 1001;
  background: #fff;
  border-bottom: 1px solid #e6eaf2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.m-search-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  font-weight: 600;
  color: #1c2d5e;
  cursor: pointer;

  .m-toggle-right {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
}

.m-cond-badge {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  background: #2a5caa;
  color: #fff;
  font-size: 12px;
  line-height: 1;
}

// ── 定位按鈕 ──────────────────────────────────────────────────
.m-map-ctrl {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1000;
}

// ── 結果列表 FAB（有結果時顯示在右下） ──────────────────────
.m-result-fab {
  position: absolute;
  bottom: 88px;
  right: 16px;
  z-index: 1000;
  background: #fff;
  color: #303133;
  border-radius: 24px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  white-space: nowrap;
  border: 1px solid #e0e0e0;

  i { font-size: 16px; color: #409EFF; }

  &:active { background: #f0f4ff; }
}

// ── 搜尋列展開內容 ─────────────────────────────────────────
.m-search-body {
  padding: 8px 12px 12px;
  overflow-y: auto;
  max-height: 50vh;

  .m-section {
    background: #fff;
    border: 1px solid #e8eaf0;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
  }

  .m-search-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .m-field-inline {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    min-width: 0;

    label {
      white-space: nowrap;
      flex-shrink: 0;
      font-weight: 600;
      font-size: 13px;
      color: #555;
    }

    > :not(label) {
      flex: 1;
      min-width: 0;
    }
  }

  .m-active-tags {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 6px;
    margin-bottom: 12px;
  }

  .m-active-tags-row {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }

  .m-active-tags-main {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    gap: 8px;
  }

  .m-active-tags-label {
    padding-top: 2px;
    flex-shrink: 0;
  }

  .m-active-tags-list {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    gap: 6px;
  }

  .m-search-actions {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }

  .m-search-actions--inline {
    margin-top: 0;
    margin-left: auto;
  }

  .m-filter-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .m-filter-label {
    font-weight: 700;
    font-size: 13px;
    color: #1c2d5e;
    flex-shrink: 0;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .m-filter-btn {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 16px;
    background: #fff;
    font-size: 13px;
    color: #303133;
    cursor: pointer;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;

    &:active { background: #f0f2f5; }
  }

  // 已廢棄，保留相容
  .m-filter-scroll {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    margin-bottom: 12px;
    -webkit-overflow-scrolling: touch;
  }

  // 已廢棄，保留相容
  .m-check-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 12px;
  }

}

// ── 右側結果列表抽屜 ─────────────────────────────────────────
.drawer-content {
  padding: 8px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

// 結果卡片
.compact-card {
  .card-container {
    display: flex;
    align-items: center;
    padding: 6px 0;

    .card-content-wrapper {
      flex: 1;
      min-width: 0;

      .card-content {
        h3 {
          margin: 0 0 4px;
          font-size: 14px;
          line-height: 1.3;

          .item-number { color: #909399; margin-right: 4px; }

          .unicodeBox { color: #303133; }
        }

        .card-branchname { margin: 0 0 2px; font-size: 13px; font-weight: 500; color: #303133; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .card-info { margin: 0; font-size: 11px; color: #909399; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      }
    }

    .card-action-buttons {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      gap: 6px;
      padding-left: 8px;
      align-items: center;

      .circular-button,
      .circular-button-green {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #409EFF;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 10px;
        gap: 2px;
        -webkit-tap-highlight-color: transparent;

        i { font-size: 14px; }

        .button-label { font-size: 9px; line-height: 1; }
      }

      .circular-button-green { background: #67C23A; }
    }
  }
}

.pageBox { padding: 8px 0; }

// ── 分頁相關抽屜覆寫 ─────────────────────────────────────────
::v-deep .el-drawer__header {
  padding: 10px 16px !important;
  margin-bottom: 0 !important;
  min-height: 44px !important;
  border-bottom: 1px solid #eee;
  font-size: 15px !important;
}

::v-deep .el-drawer__body {
  overflow-x: hidden !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

// ── 標籤抽屜內容 ─────────────────────────────────────────────
.tag-drawer-content {
  padding: 12px 16px;

  .company-info-section { margin-bottom: 16px; }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .company-details p {
    margin: 4px 0;
    font-size: 13px;
    color: #606266;
  }

  .tags-section { margin-bottom: 14px; }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    .tag-item { font-size: 12px; }
  }

  .tag-actions { padding-top: 12px; border-top: 1px solid #eee; }
}

// ── 熱門標籤對話框的 wordcloud ────────────────────────────────
.dialogBox { width: 100%; height: 260px; }

// ── 定位按鈕 Popup 自訂樣式 ──────────────────────────────────
::v-deep .custom-popup {
  .leaflet-popup-content-wrapper { border-radius: 8px; }
  .leaflet-popup-content { font-size: 13px; line-height: 1.6; }
}
</style>
